<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>
									Privacy Policy
								</span>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

		<v-container class="pa-0">
			<div class="pa-6 pa-sm-12">
				<h2 class="text-center">
					นโยบายความเป็นส่วนตัว <span class="red--text">(Privacy Policy)</span>
				</h2>

				<p class="mt-8">
					<strong>1.</strong> <strong>บทนำ</strong>
				</p>
				<p>บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด (&ldquo;บริษัท&rdquo; &quot;เรา&quot; &quot;พวกเรา&quot; หรือ &quot;ของเรา&quot;) ให้บริการเว็บไซต์ (เรียกรวมกันว่า &ldquo;เว็บไซต์&rdquo; หรือ &ldquo;เว็บ&rdquo;) แอปพลิเคชันโทรศัพท์มือถือ (เรียกรวมกันว่า (&quot;แอปพลิเคชัน&quot; หรือ &ldquo;แอป&rdquo;) และหน้าสื่อสังคมออนไลน์ ผลิตภัณฑ์และ/หรือบริการของบริษัท ในนโยบายความเป็นส่วนตัวนี้ ซึ่งเราจะเรียกเว็บไซต์ แอปพลิเคชัน หน้าสื่อสังคมออนไลน์ ผลิตภัณฑ์และ/หรือบริการ รวมกันว่า &ldquo;บริการที่เสนอให้&rdquo;</p>
				<p><br></p>
				<p>เมื่อท่านใช้บริการ เว็บไซต์หรือแอปพลิเคชันของเรา ซึ่งพัฒนา จัดการและบริหารงานโดยบริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ท่านยินยอมและไว้วางใจให้เรารักษาข้อมูลของท่าน โปรดอ่าน นโยบายความเป็นส่วนตัวเหล่านี้ด้วยความระมัดระวังก่อนทำธุรกรรมใดๆ บนเว็บไซต์หรือแอปพลิเคชันนี้</p>
				<p><br></p>
				<p>การเข้าชม การสมัครเป็นสมาชิก การใช้งาน หรือการเข้าทำข้อตกลงเกี่ยวกับบริการที่เสนอให้จะถือว่าท่านได้อ่านและยอมรับนโยบายความเป็นส่วนตัวนี้แล้ว โดยท่านควรอ่านนโยบายความเป็นส่วนตัวนี้พร้อมกับข้อกำหนดและเงื่อนไข ที่เกี่ยวข้องกับบริการที่เสนอให้ที่ท่านกำลังใช้อยู่</p>
				<p><br></p>
				<p>
					นโยบายความเป็นส่วนตัวนี้ รวมถึง
					<n-link
						to="/terms-and-conditions"
						title="Terms and Conditions"
						class="red--text"
					>
						&ldquo;ข้อกำหนดและเงื่อนไข&rdquo;
					</n-link>
					ที่เกี่ยวข้อง และเงื่อนไขทางสัญญาอื่นใดที่นำมาใช้บังคับระหว่างท่านกับบริษัท ได้ระบุวิธีการเปิดเผย หรือประมวลผลข้อมูลส่วนบุคคล ที่บริษัทเก็บรวบรวมจากท่านหรือที่ท่านได้ให้ไว้กับบริษัท และข้อกำหนดด้านล่างนี้
				</p>
				<p><br></p>
				<p>นโยบายความเป็นส่วนตัวนี้ คำว่า <span class="red--text">&ldquo;ข้อมูลส่วนบุคคล&rdquo;&nbsp;</span> หมายถึง ข้อมูลเกี่ยวกับบุคคลหนึ่ง ไม่ว่าเป็นจริงหรือไม่ก็ตามที่ทำให้ระบุตัวตนของบุคคลได้ ทั้งจากข้อมูลนั้นเองหรือจากข้อมูลนั้นเมื่อรวมกับข้อมูลอื่นซึ่งผู้ใดสามารถเข้าถึงหรืออาจจะเข้าถึงได้ บริการที่เสนอให้ มิได้มีไว้สำหรับการใช้โดยบุคคลใดก็ตามที่ยังไม่บรรลุนิติภาวะ เช่น ผู้เยาว์ หรือบุคคลที่ไม่สามารถจัดการกิจการของตนได้และ/หรือบุคคลที่มีความบกพร่องทางจิต หากท่านเป็นบุคคลประเภทดังกล่าว ให้ท่านหยุดใช้บริการที่เสนอให้โดยทันที</p>
				<p><br></p>
				<p>บริษัทให้ความสำคัญที่จะดำเนินการให้การจัดการ คุ้มครอง และประมวลผลข้อมูลส่วนบุคคลของท่านเป็นไปอย่างเหมาะสม และอาจจะมีการทบทวนนโยบาย ขั้นตอนปฏิบัติ และกระบวนการต่าง ๆ เป็นครั้งคราว โดยอาจแก้ไขเพิ่มเติมนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลาโดยจะเผยแพร่ฉบับแก้ไขบนเว็บไซต์และแอป ทั้งนี้ การที่ท่านยังคงใช้บริการที่เสนอให้ต่อไปหลังจากการเปลี่ยนแปลงดังกล่าวได้มีผลบังคับแล้วจะถือว่าท่านได้รับทราบและยอมรับนโยบายความเป็นส่วนตัวฉบับล่าสุด ขอให้ท่านตรวจสอบเว็บไซต์และแอปของบริษัทเป็นครั้งคราวสำหรับการปรับปรุงแก้ไขต่าง ๆ ในนโยบายความเป็นส่วนตัวนี้</p>
				<p><br></p>

				<p><strong>2. การเก็บรวบรวมข้อมูลส่วนบุคคล</strong></p>
				<p>เมื่อท่านใช้บริการที่เสนอให้ของบริษัท จะมีการเก็บรวบรวมข้อมูลประเภทต่าง ๆ เกี่ยวกับท่านจากอุปกรณ์ของท่าน โดยข้อมูลบางส่วนนี้สามารถใช้ระบุตัวตนท่านโดยตรง หรือสามารถใช้เพื่อระบุตัวตนท่านอย่างคร่าว ๆ เมื่อนำไปรวมกับข้อมูลอื่น ๆ</p>
				<p>หากท่านเลือกจะไม่ให้ข้อมูลบางรายการแก่บริษัท (ที่ระบุว่าเป็นข้อมูลบังคับในแบบฟอร์ม/หรือเอกสารของบริษัท) ซึ่งอาจจะทำให้ท่านไม่สามารถใช้บริการที่เสนอให้เหล่านั้นได้</p>
				<p>ในการให้บริการที่เสนอให้ โดยทั่วไปแล้วกลุ่มบริษัทจะไม่เก็บรวบรวมข้อมูลส่วนข้อมูลส่วนบุคคลที่อ่อนไหวใด ๆ ที่อาจให้คำจำกัดความไว้ภายใต้กฎหมายความเป็นส่วนตัวในประเทศ ทั้งนี้ เว้นแต่บริษัทจะร้องขอเป็นการเฉพาะ (โปรดอย่าส่งหรือให้ข้อมูลส่วนบุคคลที่อ่อนไหวใด ๆ แก่บริษัทเมื่อใช้บริการที่เสนอให้) การที่ท่านเปิดเผยข้อมูลส่วนบุคคลที่อ่อนไหวใด ๆ จะถือว่าท่านได้ให้ความยินยอมแบบครอบคลุมเพื่อให้บริษัทดำเนินการประมวลผลเพิ่มเติมเพื่อวัตถุประสงค์ใดก็ตามที่ท่านได้ให้ข้อมูลไว้</p>
				<p><br></p>
				<p class="pl-4">
					<strong>แหล่งที่มาของข้อมูลส่วนบุคคล</strong>
					<ol class="mt-4">
						<li>
							<strong>ข้อมูลส่วนบุคคลจากท่านโดยตรง</strong> บริษัทเก็บรวบรวมข้อมูลส่วนบุคคลที่ท่านให้แก่บริษัท เช่น ชื่อของท่าน ข้อมูลการติดต่อ ข้อมูลการชำระเงิน/และหรือข้อมูลทางการเงิน รายละเอียดเกี่ยวกับที่อยู่อาศัยของท่าน และบริการที่เสนอให้ที่ท่านสนใจ โดยการรวบรวมข้อมูลดังกล่าวอาจเกิดขึ้นได้จากท่านโดยตรง โดยเราจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากขั้นตอนการให้บริการดังนี้
							<ul style="list-style-type: disc; margin-left: 20px;">
								<li>เมื่อท่านลงทะเบียนบัญชีเพื่อใช้บริการกับเรา หรือเมื่อท่านยื่นคำร้องขอใช้สิทธิต่างๆ กับเรา</li>
								<li>เมื่อท่านสมัครรับข้อมูลสื่อโฆษณาหรือข้อมูลด้านการตลาดจากเรา</li>
								<li>จากความสมัครใจของท่านในการทำแบบสอบถาม</li>
								<li>จากการเก็บข้อมูลการใช้แพลตฟอร์มของท่านผ่านบราวเซอร์คุกกี้</li>
								<li>จากการติดต่อสอบถามของท่าน หรือผ่านการโต้ตอบทางอีเมลหรือ ช่องทางการสื่อสารอื่นๆ เช่น โทรศัพท์ เพื่อที่ผู้ให้บริการสามารถติดต่อท่านกลับได้</li>
								<li>เมื่อท่านกดซื้อบริการหรือผลิตภัณฑ์จากเรา</li>
								<li>เมื่อท่านเข้าถึงบริการใด ๆ ของบริษัทผ่านทางเว็บไซต์สื่อสังคมออนไลน์ เช่น Facebook, Line OA หรือผ่านทางแพลตฟอร์มดิจิทัล เช่น Google, Apple เป็นต้น</li>
								<li>เมื่อท่านติดต่อกับผู้เชี่ยวชาญด้านบริการอสังหาริมทรัพย์หรือที่อยู่อาศัย เช่น ตัวแทนหรือนายหน้าอสังหาริมทรัพย์ เจ้าหน้าที่สินเชื่อ หรืออื่น ๆ</li>
								<li>เมื่อท่านกรอกแบบฟอร์มหรือดำเนินธุรกรรมอื่น ๆ จนเสร็จสิ้น เช่น การเข้าร่วมในการสำรวจ การส่งเสริมการตลาด การขอข้อมูลสินเชื่อและ/หรือการเช่าที่อยู่อาศัย และการยื่นขอตรวจสอบประวัติ</li>
							</ul>
						</li>
						<li class="mt-4">
							<strong>คุกกี้ (Cookies) และ/หรือพิกเซล (Pixel)</strong> บริษัทใช้เทคโนโลยีต่าง ๆ เพื่อเก็บรวบรวมข้อมูลโดยอัตโนมัติเมื่อท่านเข้าถึงและใช้บริการที่เสนอให้ของบริษัท รวมถึงคุกกี้ และเทคโนโลยีอื่น ๆ ที่คล้ายคลึงกัน โดยคุกกี้เป็นส่วนของข้อมูลอิเล็กทรอนิกส์ที่สามารถโอนไปยังคอมพิวเตอร์ของท่านหรืออุปกรณ์อิเล็กทรอนิกส์อื่น ๆ เพื่อระบุตัวเบราว์เซอร์ของท่านเป็นการเฉพาะ เมื่อท่านใช้บริการที่เสนอให้ บริษัทอาจติดตั้งคุกกี้หนึ่งหรือหลายไฟล์ในคอมพิวเตอร์ของท่านหรืออุปกรณ์อิเล็กทรอนิกส์อื่น ๆ หรือใช้เทคโนโลยีอื่น ๆ ที่มีลักษณะการปฏิบัติงานที่คล้ายคลึงกัน
							<ul style="list-style-type: disc; margin-left: 20px;">
								<li>อาจใช้คุกกี้เพื่อเชื่อมโยงกิจกรรมของท่าน บนบริการที่เสนอรวมกับข้อมูลอื่น ๆ ที่บริษัทได้จัดเก็บไว้เกี่ยวกับท่าน โดยการใช้คุกกี้ช่วยบริษัทปรับปรุงคุณภาพของบริการที่เสนอให้แก่ท่าน ทำให้บริษัทสามารถระบุข้อมูลซึ่งเป็นที่น่าสนใจมากที่สุดและมอบประสบการณ์ในการใช้งานที่ดีที่สุดให้กับท่าน หรือจัดเก็บข้อมูลที่ท่านอาจค้นหาเป็นประจำ เช่น อสังหาริมทรัพย์ที่ท่านเลือกไว้หรือการค้นหาที่ท่านต้องการ ทั้งนี้ ท่านอาจปรับเปลี่ยนการตั้งค่าเบราว์เซอร์ของท่านได้ตลอดเวลาเพื่อไม่ยอมรับการใช้งานคุกกี้ตามคำสั่งจากการตั้งค่าเบราว์เซอร์ของท่าน อย่างไรก็ดี หากท่านเลือกปิดการใช้งานคุกกี้ ท่านจะไม่สามารถใช้งานคุณลักษณะหลายประการของบริการที่เสนอให้ได้อย่างเหมาะสม</li>
								<li>หน้าเว็บบางหน้า อาจมีพิกเซล ซึ่งเป็นไฟล์อิเล็กทรอนิกส์ที่ใช้เพื่อนับจำนวนผู้ใช้ที่เข้าชมหน้าเว็บนั้น เพื่อติดตามกิจกรรมในช่วงเวลาหนึ่งและไปยังเว็บไซต์ต่าง ๆ และข้อมูลนี้อาจเกี่ยวข้องกับเบราว์เซอร์ ในการระบุอุปกรณ์ หรือหมายเลขประจำคอมพิวเตอร์ในระบบเครือข่าย (IP address) เฉพาะของท่าน</li>
							</ul>
						</li>
					</ol>
					<span class="d-block mt-4 ml-4">
						ตัวอย่างเช่น บริษัทอาจใช้พิกเซลและคุกกี้เหล่านี้ เก็บรวบรวมข้อมูลเกี่ยวกับการใช้บริการที่เสนอให้แก่ท่าน รวมถึงประเภทของเบราว์เซอร์ที่ท่านใช้ เวลาที่เข้าใช้ หน้าเว็บที่ท่านเข้าชม หมายเลขประจำคอมพิวเตอร์ในระบบเครือข่าย (IP address) ของท่าน และหน้าเว็บที่ท่านเข้าชมก่อนที่จะมาเข้าใช้บริการที่เสนอให้ของบริษัท
					</span>
				</p>

				<p class="mt-8">
					<strong>3. วัตถุประสงค์ในการเก็บรวบรวม ใช้และการเปิดเผยข้อมูล</strong>
				</p>
				<p>บริษัทอาจจะรวบรวม ใช้ เปิดเผย และ/หรือประมวลผลข้อมูลส่วนบุคคลของท่าน ขึ้นอยู่กับสถานการณ์ อย่างไรก็ดี หากบริษัทจะใช้ข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ปรากฏด้านล่างนี้ บริษัทจะแจ้งให้ท่านทราบเพื่อขอความยินยอมจากท่าน เว้นแต่กฎหมายความเป็นส่วนตัวในประเทศจะอนุญาตให้มีการประมวลผลข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับความยินยอมจากท่านก่อน</p>
				<div class="pl-4">
					<strong>วัตถุประสงค์ในการเก็บรวบรวมข้อมูล</strong>
					<ol class="mt-4">
						<li>เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์ในการจัดฐานข้อมูลในการวิเคราะห์ และเสนอสิทธิประโยชน์ตามความสนใจของท่าน</li>
						<li>เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อการดำเนินการชำระเงินค่าบริการหรือสินค้าที่ท่านซื้อในระบบ</li>
						<li>เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ในการรับข้อมูลหลังการบริการ เช่น การสอบถามข้อมูล การแสดงความคิดเห็นหลังการบริการ หรือ การส่งคำร้องแก่ผู้ให้บริการ เป็นต้น</li>
						<li>เราจัดเก็บข้อมูลส่วนบุคคลเพื่อยืนยันตัวตนว่าท่านเป็นผู้เดียวในการเข้าถึงบัญชีของท่าน</li>
						<li>เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อวิจัยการตลาดและบริหารความสัมพันธ์ระหว่างผู้ซื้อและผู้ขาย สินค้า และ/หรือบริการที่เสนอให้</li>
						<li>เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อปฏิบัติตามข้อกฎหมาย และระเบียบบังคับใช้ของรัฐ</li>
					</ol>

					<p><strong>การประมวลผลข้อมูลส่วนบุคคล</strong></p>
					<p>เมื่อได้รับข้อมูลส่วนบุคคลจากท่านแล้ว เราจะดำเนินการดังนี้</p>
					<ol class="mt-4">
						<li>เก็บรวบรวมโดยมีการบันทึกในระบบคอมพิวเตอร์ ที่ใช้บริการของเว็บไซต์หรือแอปพลิเคชันของเรา</li>
						<li>
							เราจะใช้ข้อมูลส่วนบุคคลของท่านที่ได้เก็บรวบรวมมาในการดำเนินของบริษัทตามวัตถุประสงค์ที่ระบุไว้ในหัวข้อ &quot;วัตถุประสงค์ในการประมวลผลข้อมูล&quot; บริษัทดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่านภายใต้ฐาน ดังต่อไปนี้

							<ol class="mt-2">
								<li>การปฏิบัติตามสัญญา และสัญญาอื่นที่ทางเจ้าของข้อมูลส่วนบุคคลได้ทำไว้กับทางบริษัท</li>
								<li class="mt-2">
									ความยินยอม ตามที่ท่านได้ให้ความยินยอมเมื่อสมัครใช้บริการ ทั้งนี้หากท่านประสงค์จะถอนความยินยอม ท่านสามารถดำเนินการได้ดังนี้ ท่านสามารถแจ้งเพิกถอนความยินยอมในการให้ใช้หรือเปิดเผยข้อมูลในวัตถุประสงค์หรือลักษณะใดๆที่ได้ระบุไว้ข้างต้นได้ตลอดเวลา รวมถึงการร้องขอให้ลบได้ โดยติดต่อเจ้าหน้าที่ป้องกันข้อมูลส่วนบุคคลซึ่งระบุเอาไว้ด้านบน แนวทางการถอนความยินยอมประกอบไปด้วย
									<ul
										class="mt-2"
										style="list-style-type: disc; margin-left: 20px;"
									>
										<li>ช่องทางอิเล็กทรอนิกส์ อาทิ อีเมล, เว็บไซต์ หรือช่องทางสนทนาออนไลน์อื่นๆ</li>
										<li>แจ้งผ่านวาจา อาทิ โทรศัพท์ หรือ ต่อหน้าเจ้าหน้าที่ ที่เกี่ยวข้อง</li>
										<li>แจ้งผ่านลายลักษณ์อักษร</li>
									</ul>
									<p class="mt-2">
										และเมื่อได้รับคำรองของท่านแล้ว จะทำการส่งต่อให้แก่ฝ่ายบริหารจัดการข้อมูลเพื่อดำเนินการในขั้นตอนต่อไป ทั้งนี้ทางผู้ให้บริการไม่สามารถเก็บข้อมูลส่วนบุคคลของท่านหากไม่ได้รับการยินยอม เว้นแต่เพื่อวัตถุประสงค์ต่อไปนี้
									</p>
									<ul
										class="mt-2"
										style="list-style-type: disc; margin-left: 20px;"
									>
										<li>เพื่อผลประโยชน์สำคัญ และ/หรือจำเป็น เพื่อระงับหรือป้องกันอันตรายต่อชีวิต สุขภาพ หรือร่างกายของบุคคลอื่น</li>
										<li>เพื่อจัดทำเอกสารทางประวัติศาสตร์ จดหมายเหตุ การวิจัยหรือสถิติ</li>
										<li>เพื่อการปฏิบัติตามพันธะสัญญาซึ่งเจ้าของข้อมูลส่วนบุคคลเป็นคู่สัญญา</li>
										<li>เพื่อดำเนินงานตามระเบียบหรือกฎหมายของภาครัฐ หรือการใช้อำนาจรัฐของผู้ควบคุมส่วนบุคคล</li>
										<li>เพื่อประโยชน์โดยชอบด้วยกฎหมายของผู้ให้บริการ ผู้ควบคุมข้อมูลส่วนบุคคล หรือนิติบุคคลอื่น เว้นแต่ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานในการให้ข้อมูลส่วนบุคคล</li>
										<li>เพื่อประโยชน์สาธารณะของผู้ควบคุมข้อมูลส่วนบุคคล</li>
									</ul>
								</li>
								<li class="mt-2">
									บริษัทจะเปิดเผยข้อมูลกับพนักงานภายใต้สัญญาจ้างของบริษัทที่มีขอบเขตหน้าที่เกี่ยวข้องกับข้อมูลเท่านั้น เปิดเผยบนแพลตฟอร์มของบริษัท หรือช่องทางสังคมออนไลน์เพื่อการโฆษณา นอกจากนี้ เราอาจจำเป็นต้องส่งข้อมูลส่วนบุคคลของท่านไปยังหน่วยงานเพื่อตรวจสอบข้อมูล และอาจใช้ผลการตรวจสอบข้อมูลดังกล่าวเพื่อการป้องกันการฉ้อโกง
								</li>
							</ol>
						</li>
					</ol>

					<p class="mt-8">
						<strong>การใช้ข้อมูลส่วนบุคคล</strong>
					</p>
					<p>บริษัทอาจเก็บรวบรวม ใช้ และ/หรือเปิดเผย ข้อมูลส่วนบุคคลของท่านโดยประการอื่น (หรือนำข้อมูลส่วนบุคคลของท่านไปให้บุคคลภายนอก เช่น Google Analytics) เพื่อวัตถุประสงค์ดังต่อไปนี้</p>
					<p>
						1. เมื่อท่านใช้บริการที่เสนอให้ ไม่ว่าในรูปแบบใด ซึ่งบริษัทอาจประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อ
						<ul class="ml-5">
							<li>ค้นหา และบริหารจัดการบริการที่เสนอให้</li>
							<li>ปรับปรุงประสบการณ์การใช้เว็บไซต์หรือแอปพลิเคชันของท่าน โดยปรับเปลี่ยนบริการที่เสนอให้เป็นแบบส่วนตัว เช่น กรอกแบบฟอร์มโดยอัตโนมัติบนเว็บไซต์และแอป เป็นต้น</li>
							<li>ตรวจสอบตัวตนของท่านเมื่อท่านลงทะเบียนหรือลงชื่อเข้าใช้บริการที่เสนอให้ สร้าง จัดการ และปรับปรุงแก้ไขบัญชีของท่าน และดำเนินการให้มีการใช้บริการที่เสนอให้ของท่าน</li>
							<li>ดำเนินการติดตามข้อร้องเรียนหรือข้อเสนอแนะในการใช้บริการที่เสนอให้</li>
							<li>ส่งข้อมูลทั่วไปแก่ท่านผ่านช่องทางการสื่อสารใด ๆ รวมถึงแต่ไม่จำกัดเพียงอีเมล, การโทรศัพท์ด้วยเสียง (voice call), บริการข้อความสั้น (SMS), Facebook, Line OA และการแจ้งเตือนบนแอป บริษัทอาจส่งข้อมูล เพื่อวัตถุประสงค์ในทางการตลาดในกรณีที่บริษัทได้รับความยินยอมจากท่าน</li>
							<li>อำนวยความสะดวกการสื่อสารของท่านกับผู้ใช้รายอื่น รวมถึงตัวแทน นายหน้าอสังหาริมทรัพย์ หรือผู้ที่มีส่วนเกี่ยวข้อง</li>
							<li>ดำเนินการวิเคราะห์ข้อมูล การทดสอบและการวิจัย การเฝ้าติดตามและการวิเคราะห์การใช้และแนวโน้ม การพัฒนาผลิตภัณฑ์และบริการใหม่ และการปรับปรุงผลิตภัณฑ์และบริการที่มีอยู่เดิม</li>
							<li>แจ้งให้ท่านทราบเกี่ยวกับการเปลี่ยนแปลงต่าง ๆ ในบริการที่เสนอให้ของบริษัท</li>
							<li>ปฏิบัติตามกฎหมายความเป็นส่วนตัวในประเทศ คำสั่ง และคำขอทั้งหมดจากหน่วยงานในประเทศหรือต่างประเทศ ซึ่งรวมไปถึงหน่วยงานกำกับดูแล หน่วยงานภาครัฐ หน่วยงานภาษี และหน่วยงานบังคับใช้กฎหมาย หรือหน่วยงานอื่น ๆ</li>
							<li>คุ้มครองสิทธิ ทรัพย์สิน และความปลอดภัยของบริษัท ผู้ใช้บริการที่เสนอให้ และบุคคลอื่น</li>
							<li>ในส่วนที่เกี่ยวข้องกับธุรกิจฝากขาย/เช่า อสังหาริมทรัพย์, นายหน้าอสังหาริมทรัพย์ หรือผู้เชี่ยวชาญด้านบริการอสังหาริมทรัพย์หรือที่อยู่อาศัย เช่น การฝากขาย การซื้อ การขาย การเช่า หรือการสมัครเป็นตัวแทนนายหน้าอสังหาริมทรัพย์ เป็นต้น</li>
						</ul>
					</p>
					<p>
						2. เมื่อท่านใช้บริการที่เสนอให้ ในฐานะผู้ให้บริการภายนอก บริษัทอาจประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อ
						<ul class="ml-5">
							<li>ระบุตัวตนท่าน</li>
							<li>ทำให้ท่านสามารถเข้าใช้บริการของท่านได้ รวมถึงการจัดการ อำนวยความสะดวกในการใช้เว็บไซต์หรือแอปพลิเคชัน</li>
						</ul>
					</p>

					<p>
						3. เมื่อท่านใช้บริการที่เสนอให้ในฐานะนายหน้าอสังหาริมทรัพย์ หรือผู้เชี่ยวชาญด้านบริการอสังหาริมทรัพย์หรือที่อยู่อาศัย บริษัทอาจประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อ
						<ul class="ml-5">
							<li>ระบุตัวตนท่าน</li>
							<li>ดำเนินการให้ท่านสามารถเผยแพร่ และ/หรือจัดการรายการบนบริการที่เสนอให้ แก่ผู้ใช้ของบริษัท</li>
							<li>ทำการตลาดและประชาสัมพันธ์สินค้าหรือบริการของท่าน</li>
							<li>อำนวยความสะดวกท่าน ในการแจ้งข่าวสารและกิจกรรมต่างๆ ของบริษัท</li>
						</ul>
					</p>
					<p>
						4. เมื่อท่านส่งข้อมูลส่วนบุคคลให้แก่บริษัทเกี่ยวกับโอกาสการสมัครเข้าทำงาน กลุ่มบริษัทอาจประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อ
						<ul class="ml-5">
							<li>พิจารณา และ/หรือตอบรับท่าน สำหรับตำแหน่งงานที่ท่านได้ส่งข้อมูลส่วนบุคคลให้แก่บริษัท</li>
							<li>ติดต่อบุคคลอ้างอิงของท่านเพื่อเก็บรวบรวมข้อมูลที่ท่านให้ความยินยอมแก่บริษัทในการเก็บรวบรวม เพื่อพิจารณาท่านสำหรับโอกาสการสมัครเข้าทำงานกับบริษัท</li>
							<li>อำนวยความสะดวก ในการแจ้งเงื่อนไขการชำระค่าสินค้าหรือบริการ ให้แก่ท่านจนเสร็จสิ้นกระบวนการ</li>
						</ul>
					</p>
					<p>5. หากท่านขอข้อมูลจากบุคคลภายนอกใด ๆ ผ่านทางบริการที่เสนอให้ ท่านจะต้องตรวจสอบนโยบายความเป็นส่วนตัวของบุคคลภายนอกรายนั้น เพื่อให้แน่ใจว่าท่านพอใจกับวิธีที่บุคคลภายนอกเหล่านั้นจะป้องกันหรือใช้ข้อมูลส่วนบุคคลของท่าน บริษัทจะไม่รับผิดชอบต่อความเสียหายอะไรก็ตาม ในทุกกรณีที่บุคคลภายนอกเหล่านั้นทำกับข้อมูลส่วนบุคคลที่ท่านให้ไว้แก่บุคคลภายนอกดังกล่าวที่ท่านขอข้อมูลไป</p>
					<p>6. บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านต่อบุคคลภายนอกเพื่อวัตถุประสงค์ด้านการตลาดแบบตรง โดยไม่ได้รับความยินยอมที่แจ้งชัดจากท่าน</p>

					<p class="mt-8">
						<strong>สิทธิของเจ้าของข้อมูล</strong>
					</p>
					<p>ท่านมีสิทธิในการดำเนินการ ดังต่อไปนี้</p>
					<p>1. สิทธิในการได้รับแจ้ง (right to be informed) ท่านมีสิทธิที่จะได้รับแจ้งเมื่อข้อมูลส่วนบุคคลของท่านถูกจัดเก็บ รวมถึงรายละเอียดต่างๆที่เกี่ยวข้อง</p>
					<p>2. สิทธิในการเพิกถอนความยินยอม (right to withdraw consent) ท่านมีสิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับเราได้ ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่กับเรา</p>
					<p>3. สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access) ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้เราทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน รวมถึงขอให้เราเปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลที่ท่านไม่ได้ให้ความยินยอมต่อเรา</p>
					<p>4. สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to rectification) ท่านมีสิทธิในการขอให้เราแก้ไขข้อมูลที่ไม่ถูกต้องหรือเพิ่มเติมข้อมูลที่ไม่สมบูรณ์</p>
					<p>5. สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure) ท่านมีสิทธิในการขอให้เราทำการลบข้อมูลของท่านด้วยเหตุบางประการได้</p>
					<p>6. สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of processing) ท่านมีสิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้</p>
					<p>7. สิทธิในการให้โอนย้ายข้อมูลส่วนบุคคล (right to data portability) ท่านมีสิทธิในการโอนย้ายข้อมูลส่วนบุคคลของท่านไปให้แก่ผู้ควบคุมข้อมูลรายอื่นหรือตัวท่านเองด้วยเหตุบางประการได้</p>
					<p>8. สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object) ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้</p>

					<p class="mt-8">
						<strong>การเปิดเผยข้อมูลส่วนบุคคลของคุณ</strong>
					</p>
					<p>บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลของคุณให้บริษัทที่เกี่ยวข้อง ผู้ให้บริการและหุ้นส่วนทางธุรกิจของเรา นอกจากนี้เรายังสามารถเปิดเผยข้อมูลส่วนบุคคลของคุณ</p>
					<p>1. ให้แก่ตัวแทน นายหน้าอสังหาริมทรัพย์ หุ้นส่วนทางธุรกิจ หรือผู้เชี่ยวชาญด้านบริการอสังหาริมทรัพย์หรือที่อยู่อาศัย</p>
					<p>2. หน่วยงานของรัฐบาล หรือหน่วยงานที่เกี่ยวข้อง หรือบุคคลที่เกี่ยวข้อง ในกรณีที่มีเหตุผลให้เชื่อได้ว่าการเปิดเผยข้อมูลส่วนบุคคลของคุณจะช่วยระบุ ติดต่อ หรือดำเนินการทางกฎหมายต่อบุคคลที่ทำให้เกิดความเสียหาย การบาดเจ็บ หรือการแทรกแซง (ไม่ว่าโดยเจตนาหรือไม่เจตนา) ต่อสิทธิหรือทรัพย์สินของบริษัท ผู้ใช้เว็บไซต์หรือแอปพลิเคชันของเรา หรือบุคคลอื่นที่เกิดความเสียหาย</p>
					<p>3. เมื่อบทบัญญัติกฎหมายอนุญาต หรือกำหนดให้เราต้องเปิดเผยข้อมูลส่วนบุคคลของคุณ</p>
					<p><br></p>
					<p>ในกรณีที่คุณขอข้อมูลจากองค์กรใดๆ ก็ตามผ่านทางเว็บไซต์ของเรา คุณต้องตรวจสอบนโยบายข้อมูลส่วนบุคคลขององค์กรดังกล่าวเพื่อให้ทราบว่าองค์กรนั้นมีวิธีการจัดการข้อมูลส่วนบุคคลอย่างไร โดยเราจะไม่รับผิดชอบต่อวิธีการที่องค์กรดังกล่าวเก็บรวบรวม ใช้ เปิดเผย เก็บรักษา ประมวลผล หรือจัดการข้อมูลส่วนบุคคลที่คุณให้แก่องค์กรดังกล่าวผ่านทางเว็บไซต์ของเรา</p>
					<p><br></p>
					<p>ท่านสามารถติดต่อมายังเจ้าหน้าที่ DPO หรือเจ้าหน้าที่ฝ่ายควบคุมข้อมูลของเราได้ เพื่อดำเนินการยื่นคำร้องขอดำเนินการตามสิทธิข้างต้นได้ หรือท่านสามารถศึกษารายละเอียดเงื่อนไข ข้อยกเว้นการใช้สิทธิต่างๆ ได้ที่ แนวปฏิบัติเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล (TDPG2.0) และ เว็บไซต์กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม http://www.mdes.go.th</p>
					<p>ทั้งนี้ ท่านไม่จำเป็นต้องเสียค่าใช้จ่ายใดๆ ในการดำเนินตามสิทธิข้างต้น โดยเราจะพิจารณา และแจ้งผลการพิจารณาคำร้องของท่านภายใน 30 วันนับแต่วันที่เราได้รับคำร้องขอดังกล่าว</p>
				</div>



				<p><br></p>
				<p><strong>4. นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์อื่น</strong></p>
				<p>นโยบายความเป็นส่วนตัวฉบับนี้ ใช้เฉพาะสำหรับการให้บริการของเราและการใช้งานเว็บไซต์หรือแอปพลิเคชันของเราเท่านั้น ซึ่งบริการที่เสนอให้อาจมีลิงก์ไปยังหรือจากเว็บไซต์ของเครือข่ายพันธมิตร บริษัทยังอนุญาตให้บุคคลภายนอกบางรายแสดงแอปพลิเคชันและ/หรือวิดเจ็ต (widget) ของตนบนบริการที่เสนอให้ของบริษัทได้ด้วย ซึ่งทำให้ท่านสามารถโต้ตอบหรือแบ่งปันเนื้อหา รวมถึงผ่านทางปุ่มสื่อสังคมออนไลน์ เช่น ปุ่ม &lsquo;แบ่งปัน (share)&rsquo; และ &lsquo;ถูกใจ (like)&rsquo; ของ Facebook โดยเว็บไซต์ แอปพลิเคชั่น และวิดเจ็ตที่มีลิงก์เชื่อมโยงเหล่านี้อยู่นอกเหนือความควบคุมของบริษัท และบริษัทไม่สามารถรับผิดชอบต่อการดำเนินการของบริษัทต่าง ๆ ที่มีลิงก์เชื่อมโยงกับเว็บไซต์และ/หรือแอปของบริษัท หรือการที่บริษัทดังกล่าวเก็บรวบรวมข้อมูลผ่านทางแอปพลิเคชันและ/หรือวิดเจ็ตของบุคคลภายนอกเหล่านี้ ในกรณีที่ท่านกดเข้าลิงก์ไปยังเว็บไซต์ใด ๆ โปรดทราบว่าเว็บไซต์เหล่านี้มีนโยบายความเป็นส่วนตัวของตนเองและบริษัทจะไม่รับผิดชอบหรือรับผิดสำหรับนโยบายดังกล่าว ทั้งนี้ หากท่านได้กดลิ้งก์ไปยังเว็บไซต์อื่น แม้จะผ่านช่องทางในเว็บไซต์ของเราก็ตาม ท่านจะต้องศึกษาและปฏิบัติตามนโยบายความเป็นส่วนตัวที่ปรากฏในเว็บไซต์นั้นๆ แยกจากของเว็บไซต์หรือแอปพลิเคชันของเราอย่างสิ้นเชิงโปรดอ่านและยอมรับนโยบาย และข้อกำหนดและเงื่อนไขดังกล่าวก่อนที่ท่านจะนำส่งข้อมูลส่วนบุคคลใด ๆ ไปยังเว็บไซต์เหล่านี้</p>
				<p><br></p>
				<p><strong>5. การปฏิเสธความรับผิดและข้อจำกัดความรับผิด</strong></p>
				<p>คุณจะต้องยอมรับว่า เมื่อคุณเข้าใช้บริการเว็บไซต์หรือแอปพลิเคชันนี้แล้ว คุณต้องรับผิดชอบ ต่อกระทำการใดๆ ที่จะเป็นการล่วงละเมิดสิทธิส่วนบุคคล และ/หรือสิทธิ์ในทรัพย์สินทางปัญญา ทั้งบุคคลภายนอกและ/หรือ ของเรา สำหรับค่าใช้จ่ายทั้งหมดที่จะเกิดขึ้น (ถ้ามี) จากการเข้าใช้งานของคุณ บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด, กรรมการของบริษัท, พนักงานหรือตัวแทนอื่นๆ จะไม่รับผิดชอบต่อความเสียหายใดๆ, ความสูญเสีย, ค่าใช้จ่าย, การเรียกร้องหรือความต้องการใดๆ, ไม่ว่าจะโดยตรง, โดยอ้อม, การชดเชยหรือผลเสียหายที่เกิดขึ้น, ความเกี่ยวข้องกับการใช้งานเว็บไซต์หรือแอปพลิเคชันนี้ของคุณ หรือข้อมูลเนื้อหา, ส่วนประกอบหรือผลิตภัณฑ์ที่รวมอยู่บนเว็บไซต์นี้ หลักเกณฑ์เหล่านี้ อยู่ภายใต้กฎหมายของประเทศไทย หากเกิดข้อพิพาทใดๆ จะได้รับการแก้ไขโดยศาลยุติธรรมของไทยที่มีอำนาจพิจารณาพิพากษาชี้ขาดเป็นไปตามเงื่อนไขที่บริษัทกำหนด อีกทั้งบริษัทจะไม่รับผิดต่อการที่ท่านเปิดเผยข้อมูลส่วนบุคคลต่อผู้ใช้รายอื่น ๆ โดยสมัครใจเกี่ยวกับการใช้บริการที่เสนอให้</p>
				<p><br></p>
				<p><strong><u>ช่องทางการติดต่อ</u></strong></p>
				<p><strong>บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด</strong></p>
				<p>สำนักงานใหญ่ เลขที่ 40/88 ซอยมัณฑนา หมู่ 5 ตำบลบางเมือง&nbsp;&nbsp;อำเภอเมือง&nbsp;&nbsp;จังหวัดสมุทรปราการ</p>
				<p>
					ช่องทางการติดต่อ:
					<a
						href="tel:02-047-4282"
						class="red--text"
					>
						(+66) 02-047-4282
					</a>
				</p>
				<p>
					Website :
					<a
						href="https://tb.co.th"
						class="red--text"
					>
						https://tb.co.th
					</a>
				</p>
				<p>
					Line :
					<a
						href="https://line.me/ti/p/~@thebestproperty"
						class="red--text"
						title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
						target="_blank"
					>
						@thebestproperty
					</a>
				</p>
				<p><strong><br><br></strong><strong>รายละเอียดหน่วยงานกำกับดูแล</strong></p>
				<p>ในกรณีที่พนักงานของเราหรือบุคคลที่เกี่ยวข้องฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล ท่านสามารถร้องเรียนต่อหน่วยงานกำกับดูแลตามรายละเอียดดังนี้</p>
				<p><br></p>
				<p><strong>สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล</strong></p>
				<p>สถานที่ติดต่อ: ชั้น 7 อาคารรัฐประศาสนภักดี ศูนย์ราชการ เฉลิมพระเกียรติ 80 พรรษาฯ ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพมหานคร 10210</p>
				<p>
					ช่องทางการติดต่อ:
					<a
						href="tel:02-142-2233"
						class="red--text"
					>
						(+66) 02-142-2233
					</a>
				</p>
			</div>
		</v-container>
	</v-main>
</template>

<script>
const doc = 'privacyPolicy'

import { mapGetters } from 'vuex'

export default {
	// scrollToTop: true,
	name: 'PRIVACYPOLICY',
	layout: 'default_2',

	components: {

	},

	async fetch(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath
		}
		await context.store.dispatch('page/initial', data)
	},

	data:() => ({
		loading: false,
	}),

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			head: 'page/head',
		}),
	},

	watch: {

	},

	created() {

	},

	mounted() {

	},

	methods: {

	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.red-strip {
		border: solid 2px #c20000;
		width: 40px;
	}
}

</style>
